import { useState, useEffect } from 'react';

const AnimatedNumber = ({ targetNumber }) => {
  const [currentNumber, setCurrentNumber] = useState(0);

  useEffect(() => {
    const increment = targetNumber / 100;
    const interval = setInterval(() => {
      setCurrentNumber(prevNumber => {
        const newNumber = prevNumber + increment;
        if (newNumber >= targetNumber) {
          clearInterval(interval);
          return targetNumber;
        }
        return newNumber;
      });
    }, 20);

    return () => clearInterval(interval);
  }, [targetNumber]);

  return Math.floor(currentNumber).toLocaleString('es-AR');
};

export default AnimatedNumber;